<template>
    <div class="card" :class="customClass">
        <div class="card-body">
            <span class="box-title">{{ title }}</span>
        </div>
        <div class="card-footer text-end border-top-0" :class="customClass">{{ description }}</div>
    </div>
</template>

<script setup lang="ts">
const {title, description, customClass} = defineProps<{
    title: string,
    description: string,
    customClass?: string[]
}>()
</script>

<style scoped>
.box-title {
    font-size: calc(4rem + 1.5vw);
}
</style>
